<template>
  <div class="honor-box">
    <div class="honor-content-box">
      <div class="en-title">{{ "Company Honors".toUpperCase() }}</div>
      <div class="cn-title">公司荣誉</div>
      <div class="honor-content">
        <div class="honor-item" v-for="(item, index) in list" :key="index">
          <div class="before-icon"></div>
          <div class="honor-text">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      itemList: [
        "希夷购物商城系统（简称：希夷SHOP）V1.0",
        "鹿鸣美业管理平台（简称：鹿鸣美业）V1.0",
        "山木枝云支付小程序平台（简称：云支付）V1.0",
        "门店活动推广平台（简称：千店）V1.0",
        "图书馆微信公众服务平台（简称：图书馆）V1.0",
        "客户语言服务监督系统（简称：语言监督系统）V1.0",
        "山木枝“文档内部管理”（简称：文档系统）V1.0",
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
